import { render, staticRenderFns } from "./chapters-import.vue?vue&type=template&id=2de9f0b2"
import script from "./chapters-import.vue?vue&type=script&lang=js"
export * from "./chapters-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports